import { Provider } from '@angular/core';
import {
  AddCategoryUseCase,
  AddChecklistItemUseCase,
  AddItemUseCase,
  BulkDeleteItemUseCase,
  CreateAssetTypeUseCase,
  DeleteAssetItemUseCase,
  DeleteCategoryUseCase,
  DeleteChecklistItemUseCase,
  DetailAssetItemUseCase,
  EditAssetItemUseCase,
  EditCategoryUseCase,
  GetAssetStatusUseCase,
  GetCategoryUseCase,
  GetChecklistDetailUseCase,
  GetChecklistUseCase,
  GetCollectReturnDetailUseCase,
  GetCollectReturnUseCase,
  GetDetailAssetTypeUseCase,
  GetEditDetailAssetTypeUseCase,
  GetListAssetTypeUseCase,
  UpdateAssetTypeUseCase,
  UpdateChecklistItemUseCase,
  UpdateStatusUseCase,
} from '@app/application';
import { AssetsRepository } from '@app/domain';
import { AssetsRepositoryImpl } from '../repositories';

export const ASSETS_PROVIDERS: Provider[] = [
  // Repositories
  {
    provide: AssetsRepository,
    useClass: AssetsRepositoryImpl,
  },
  {
    provide: GetListAssetTypeUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetListAssetTypeUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: CreateAssetTypeUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new CreateAssetTypeUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: GetDetailAssetTypeUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetDetailAssetTypeUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: GetAssetStatusUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetAssetStatusUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: AddItemUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new AddItemUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: BulkDeleteItemUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new BulkDeleteItemUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: GetChecklistUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetChecklistUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: GetCollectReturnUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetCollectReturnUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  // Category methods Start
  {
    provide: GetCategoryUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetCategoryUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: AddCategoryUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new AddCategoryUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: EditCategoryUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new EditCategoryUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: DeleteCategoryUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new DeleteCategoryUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  // Category methods end

  {
    provide: AddChecklistItemUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new AddChecklistItemUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: GetChecklistDetailUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetChecklistDetailUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: GetCollectReturnDetailUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetCollectReturnDetailUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: UpdateChecklistItemUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new UpdateChecklistItemUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: UpdateStatusUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new UpdateStatusUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: DeleteChecklistItemUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new DeleteChecklistItemUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: DeleteAssetItemUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new DeleteAssetItemUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  // Edit Asset type methods

  {
    provide: GetEditDetailAssetTypeUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new GetEditDetailAssetTypeUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: UpdateAssetTypeUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new UpdateAssetTypeUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  // Edit Asset Item methods

  {
    provide: DetailAssetItemUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new DetailAssetItemUseCase(assetsRepo),
    deps: [AssetsRepository],
  },

  {
    provide: EditAssetItemUseCase,
    useFactory: (assetsRepo: AssetsRepository) =>
      new EditAssetItemUseCase(assetsRepo),
    deps: [AssetsRepository],
  },
];
